import { render, staticRenderFns } from "./VideoAnnotator.vue?vue&type=template&id=fb6f3074&scoped=true"
import script from "./VideoAnnotator.vue?vue&type=script&lang=ts"
export * from "./VideoAnnotator.vue?vue&type=script&lang=ts"
import style0 from "./VideoAnnotator.vue?vue&type=style&index=0&id=fb6f3074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f3074",
  null
  
)

export default component.exports